export const enRideSharing = {
  hero: {
    title: "The smart taxi solution/platform",
    subtitle: "Ready-to-deploy solution for taxi and package delivery services",
    imageAlt: "Ride-sharing app interface showing live tracking"
  },
  features: {
    rideSharing: {
      title: "Ride-Sharing System",
      description: "Complete carpooling solution with driver and passenger apps, fare calculation, and ride matching"
    },
    packageDelivery: {
      title: "Package Delivery",
      description: "On-demand delivery services with real-time tracking and proof of delivery"
    },
    auctionSystem: {
      title: "Dynamic Bidding System",
      description: "Smart pricing algorithm for delivery services based on demand and availability"
    },
    realTimeTracking: {
      title: "Real-Time GPS Tracking",
      description: "Live location tracking with interactive maps and ETA predictions"
    },
    paymentGateways: {
      title: "Payment Solutions",
      description: "Multiple payment options including Stripe, PayPal, bKash with secure transactions"
    },
    loyaltyProgram: {
      title: "Loyalty Rewards",
      description: "Customizable reward system for frequent users and top-rated drivers"
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 framework for robust operations",
      php: "PHP 8.2+ with performance optimizations",
      architecture: "Microservices architecture with API gateway"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 for cross-platform mobile apps",
      web: "React.js with Next.js for admin dashboard",
      state: "Redux for complex state management"
    },
    integrations: {
      title: "Integrations",
      maps: "Google Maps and Mapbox integration",
      payments: "Multiple payment gateway support",
      communication: "Twilio/TunisieSmS for SMS/OTP and notifications"
    }
  },
  dashboard: {
    title: "Comprehensive Management Dashboard",
    description: "Complete control over your transportation platform with real-time monitoring",
    demoAlt: "Ride-sharing admin dashboard preview",
    features: {
      "1": "Unified ride-sharing and delivery management",
      "2": "Real-time fleet tracking and analytics",
      "3": "Dynamic pricing and commission system",
      "4": "Driver and customer support tools",
      "5": "Business performance reporting"
    }
  },
  cta: {
    title: "Ready to Launch Your Transportation Platform?",
    description: "Discover how our solution can power your ride-sharing and delivery business",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the ride-sharing platform"
  }
};


export const frRideSharing = {
  hero: {
    title: "Solution/Plateforme de Taxi intelligente",
    subtitle: "Solution prête à déployer pour les services de taxi et de livraison de colis",
    imageAlt: "Interface de l'application de covoiturage montrant le suivi en direct"
  },
  features: {
    rideSharing: {
      title: "Système de covoiturage",
      description: "Solution complète de covoiturage avec applications pour conducteurs et passagers, calcul des tarifs et mise en relation des trajets"
    },
    packageDelivery: {
      title: "Livraison de colis",
      description: "Services de livraison à la demande avec suivi en temps réel et preuve de livraison"
    },
    auctionSystem: {
      title: "Système d'enchères dynamique",
      description: "Algorithme de tarification intelligent pour les services de livraison basé sur la demande et la disponibilité"
    },
    realTimeTracking: {
      title: "Suivi GPS en temps réel",
      description: "Suivi de localisation en direct avec cartes interactives et prévisions d'ETA"
    },
    paymentGateways: {
      title: "Solutions de paiement",
      description: "Multiples options de paiement incluant Stripe, PayPal, bKash avec transactions sécurisées"
    },
    loyaltyProgram: {
      title: "Récompenses de fidélité",
      description: "Système de récompenses personnalisable pour les utilisateurs fréquents et les conducteurs les mieux notés"
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Framework Laravel 10 pour des opérations robustes",
      php: "PHP 8.2+ avec optimisations de performance",
      architecture: "Architecture microservices avec passerelle API"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 pour des applications mobiles multiplateformes",
      web: "React.js avec Next.js pour le tableau de bord administrateur",
      state: "Redux pour la gestion d'état complexe"
    },
    integrations: {
      title: "Intégrations",
      maps: "Intégration de Google Maps et Mapbox",
      payments: "Support de plusieurs passerelles de paiement",
      communication: "Twilio/TunisieSmS pour SMS/OTP et notifications"
    }
  },
  dashboard: {
    title: "Tableau de bord de gestion complet",
    description: "Contrôle total de votre plateforme de transport avec surveillance en temps réel",
    demoAlt: "Aperçu du tableau de bord administrateur de covoiturage",
    features: {
      "1": "Gestion unifiée du covoiturage et de la livraison",
      "2": "Suivi de flotte en temps réel et analyses",
      "3": "Tarification dynamique et système de commission",
      "4": "Outils de support pour conducteurs et clients",
      "5": "Reporting sur la performance commerciale"
    }
  },
  cta: {
    title: "Prêt à lancer votre plateforme de transport?",
    description: "Découvrez comment notre solution peut alimenter votre activité de covoiturage et de livraison",
    buttonText: "Voir la démo",
    buttonAriaLabel: "Voir la démo de la plateforme de covoiturage"
  }
};

export const nlRideSharing = {
  hero: {
    title: "De slimme taxi-oplossing/platform",
    subtitle: "Klaar-om-te-implementeren oplossing voor taxi- en pakketbezorgdiensten",
    imageAlt: "Ride-sharing app-interface toont live tracking"
  },
  features: {
    rideSharing: {
      title: "Ride-Sharing Systeem",
      description: "Complete carpooloplossing met apps voor chauffeurs en passagiers, tariefberekening en ritmatching"
    },
    packageDelivery: {
      title: "Pakketbezorging",
      description: "On-demand bezorgdiensten met realtime tracking en bezorgbewijs"
    },
    auctionSystem: {
      title: "Dynamisch biedsysteem",
      description: "Slim prijsalgoritme voor bezorgdiensten op basis van vraag en beschikbaarheid"
    },
    realTimeTracking: {
      title: "Realtime GPS-tracking",
      description: "Live locatie-tracking met interactieve kaarten en ETA-voorspellingen"
    },
    paymentGateways: {
      title: "Betaaloplossingen",
      description: "Meerdere betaalopties waaronder Stripe, PayPal, bKash met veilige transacties"
    },
    loyaltyProgram: {
      title: "Loyalty Beloningen",
      description: "Aanpasbaar beloningssysteem voor frequente gebruikers en best beoordeelde chauffeurs"
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 framework voor robuuste operaties",
      php: "PHP 8.2+ met prestatieoptimalisaties",
      architecture: "Microservices-architectuur met API-gateway"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 voor cross-platform mobiele apps",
      web: "React.js met Next.js voor admin dashboard",
      state: "Redux voor complexe state management"
    },
    integrations: {
      title: "Integraties",
      maps: "Google Maps en Mapbox-integratie",
      payments: "Ondersteuning voor meerdere betaalgateways",
      communication: "Twilio/TunisieSmS voor SMS/OTP en notificaties"
    }
  },
  dashboard: {
    title: "Uitgebreid Beheerdashboard",
    description: "Volledige controle over uw transportplatform met realtime monitoring",
    demoAlt: "Preview van ride-sharing admin dashboard",
    features: {
      "1": "Geïntegreerd beheer van ride-sharing en bezorging",
      "2": "Realtime vloottracking en analytics",
      "3": "Dynamisch prijs- en commissiesysteem",
      "4": "Supporttools voor chauffeurs en klanten",
      "5": "Rapportage over bedrijfsresultaten"
    }
  },
  cta: {
    title: "Klaar om uw transportplatform te lanceren?",
    description: "Ontdek hoe onze oplossing uw ride-sharing en bezorgbedrijf kan aandrijven",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het ride-sharing platform"
  }
};

export const deRideSharing = {
  hero: {
    title: "Die intelligente Taxilösung/Plattform",
    subtitle: "Einsatzbereite Lösung für Taxi- und Paketlieferdienste",
    imageAlt: "Ride-Sharing-App-Oberfläche zeigt Live-Tracking"
  },
  features: {
    rideSharing: {
      title: "Ride-Sharing-System",
      description: "Komplette Carpooling-Lösung mit Fahrer- und Passagier-Apps, Fahrpreisberechnung und Fahrtenvermittlung"
    },
    packageDelivery: {
      title: "Paketlieferung",
      description: "On-Demand-Lieferdienste mit Echtzeit-Tracking und Zustellnachweis"
    },
    auctionSystem: {
      title: "Dynamisches Bietsystem",
      description: "Intelligenter Preisalgorithmus für Lieferdienste basierend auf Nachfrage und Verfügbarkeit"
    },
    realTimeTracking: {
      title: "Echtzeit-GPS-Tracking",
      description: "Live-Standortverfolgung mit interaktiven Karten und ETA-Vorhersagen"
    },
    paymentGateways: {
      title: "Zahlungslösungen",
      description: "Mehrere Zahlungsoptionen einschließlich Stripe, PayPal, bKash mit sicheren Transaktionen"
    },
    loyaltyProgram: {
      title: "Loyalty-Prämien",
      description: "Anpassbares Belohnungssystem für Vielnutzer und top-bewertete Fahrer"
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 Framework für robuste Abläufe",
      php: "PHP 8.2+ mit Leistungsoptimierungen",
      architecture: "Microservices-Architektur mit API-Gateway"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 für plattformübergreifende mobile Apps",
      web: "React.js mit Next.js für das Admin-Dashboard",
      state: "Redux für komplexes State Management"
    },
    integrations: {
      title: "Integrationen",
      maps: "Google Maps und Mapbox-Integration",
      payments: "Unterstützung mehrerer Zahlungs-Gateways",
      communication: "Twilio/TunisieSmS für SMS/OTP und Benachrichtigungen"
    }
  },
  dashboard: {
    title: "Umfassendes Verwaltungsdashboard",
    description: "Vollständige Kontrolle über Ihre Transportplattform mit Echtzeitüberwachung",
    demoAlt: "Vorschau des Ride-Sharing-Admin-Dashboards",
    features: {
      "1": "Vereinheitlichtes Ride-Sharing- und Liefermanagement",
      "2": "Echtzeit-Flottenverfolgung und Analytik",
      "3": "Dynamisches Preis- und Provisionssystem",
      "4": "Support-Tools für Fahrer und Kunden",
      "5": "Geschäftsleistungsberichte"
    }
  },
  cta: {
    title: "Bereit, Ihre Transportplattform zu starten?",
    description: "Erfahren Sie, wie unsere Lösung Ihr Ride-Sharing- und Liefergeschäft antreiben kann",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der Ride-Sharing-Plattform ansehen"
  }
};